import { IServerSubscriptionUsage, ISubscriptionUsage } from '@/store/contracts/subscriptions/transactions';

export function toApp (serverModel: IServerSubscriptionUsage): ISubscriptionUsage {
  return {
    serviceType: serverModel.ServiceType,
    recordedDay: new Date(serverModel.RecordedDay),
    transactionCount: serverModel.TransactionCount,
    transactionCountNormalized: serverModel.TransactionCount
  };
}
